import React, { Component } from 'react';
import PageNotFound from 'legacy/src/components/PageNotFound';
import { get } from 'lodash';

/**
 * Check for the right IDs that were looking for in the URL param and redirect to PageNotFound if:
 *  the value is not undefined and not a number
 *  the subject is a number but the user has no access to it
 */

const URL_KEY_PARAMS = [
  'subject',
  'assessmentId',
  'assignmentId',
  'studentId',
  'previewId',
  'subjectId',
  'questionId',
];

let ValidatedRoute = (ComposedComponent) =>
  class extends Component {
    getUserSubject = (subjects, id) =>
      subjects.find((subject) => subject.id === id);

    isValidUserSubject = (subjects, subjectId) => {
      const userSubject = this.getUserSubject(subjects, subjectId);
      return !!get(userSubject, 'id');
    };

    render() {
      const { params } = this.props?.router || {};

      // eslint-disable-next-line no-unused-vars
      for (const [key, value] of Object.entries(params || {})) {
        const isNumber = (value) => !Number.isNaN(Number(value));
        if (
          URL_KEY_PARAMS.includes(key) &&
          value !== undefined &&
          !isNumber(value)
        ) {
          /**
           * One of the exceptions here is previewId can be 'filters' when e.g.
           * clicking the Topic Questions filter from the Unit Outline.
           * When previewId is "filters" we can assume it is ok.
           */
          const topicQuestionURL = key === 'previewId' && value === 'filters';
          /**
           * Let's minimize how many exceptions we create, this was existing functionality
           * that got broken by having stricter URLs
           */
          const meetsExceptionCase = topicQuestionURL;
          if (!meetsExceptionCase) return <PageNotFound />;
        } else if (
          ['subject', 'subjectId'].includes(key) &&
          isNumber(value) &&
          !params?.shareKey
        ) {
          const { isTeacher, isStudent } = this.props.userData || {};
          if (isTeacher) {
            const validUserSubject = this.isValidUserSubject(
              this.props.userData.teacherSubjects,
              value,
            );
            if (!validUserSubject) {
              return <PageNotFound />;
            }
          } else if (isStudent) {
            const validUserSubject = this.isValidUserSubject(
              this.props.userData.studentSubjects,
              value,
            );
            if (!validUserSubject) {
              return <PageNotFound />;
            }
          }
        }
      }
      return <ComposedComponent {...this.props} />;
    }
  };

export default ValidatedRoute;
